import React, { useState, useEffect } from 'react';
import API from '../utils/axios';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { TermsModal } from '../components/TermsModal';
import { InlinePredictionCard } from '../components/InlinePredictionCard';
import { Calendar } from 'lucide-react';

export const Schedule = () => {
  const [matches, setMatches] = useState([]);
  const [websites, setWebsites] = useState([]);
  const [filter, setFilter] = useState('all');
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const url = filter === 'all' ? '/matches' : `/matches?status=${filter}`;
        const { data } = await API.get(url);
        setMatches(data);
      } catch (e) {}
    })();
  }, [filter]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await API.get('/websites');
        setWebsites(data);
      } catch (e) {}
    })();
  }, []);

  return (
    <div className="App">
      <Header />

      <section className="py-24 container mx-auto px-4 min-h-screen">
        <div className="text-center mb-12">
          <Calendar className="inline-block text-[#FFD60A] mb-4" size={48} />
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4 tracking-tight" data-testid="schedule-title">
            Rundown Pertandingan
          </h1>
          <p className="text-gray-400 text-lg">Pilih pertandingan dan tebak skornya langsung di sini</p>
        </div>

        <div className="flex justify-center gap-4 mb-12 flex-wrap">
          {[['all','Semua'],['today','Hari Ini'],['upcoming','Mendatang'],['finished','Selesai']].map(([k,l]) => (
            <button
              key={k}
              onClick={() => setFilter(k)}
              className={`px-6 py-2 rounded-full font-semibold transition-all ${
                filter === k ? 'bg-[#D90429] text-white' : 'bg-white/10 text-gray-300 hover:bg-white/20'
              }`}
              data-testid={`filter-${k}`}
            >{l}</button>
          ))}
        </div>

        {matches.length === 0 ? (
          <div className="text-center py-12"><p className="text-gray-400 text-lg">Tidak ada pertandingan</p></div>
        ) : (
          <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto">
            {matches.map((match) => (
              <InlinePredictionCard
                key={match.id}
                match={match}
                websites={websites}
                onTermsClick={() => setShowTerms(true)}
              />
            ))}
          </div>
        )}
      </section>

      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} />

      <Footer />
    </div>
  );
};
